import './lib/connective-plugin-6.0.0-wrapper-legacy-interop.min';

import type {
  ConnectiveReader,
  ConnectiveSignaturePluginApi,
  PersonalInfo,
  SignatureCertificates,
} from './types';

declare const connective: {
  ConnectivePluginApi: new () => ConnectiveSignaturePluginApi;
};

class ConnectivePluginService {
  pluginApi: ConnectiveSignaturePluginApi = new connective.ConnectivePluginApi();

  initializePlugin = () =>
    this.pluginApi.initialize().then(() => this.pluginApi.checkIfPluginIsInstalled());

  activate = (activationToken: Record<string, unknown>) => this.pluginApi.activate(activationToken);

  waitForEIdCard = () => {
    // The plugin wrapper keep the last value of the stopPolling call => Reset it !
    this.pluginApi.shouldStopPollingForReader = false;
    this.pluginApi.shouldStopPollingForReaders = false;
    return this.pluginApi.pollForReader();
  };

  readEIdCertificates = (): Promise<SignatureCertificates> =>
    this.pluginApi
      .pollForReader(1000, 2)
      .then((reader: ConnectiveReader) => reader.readCertificates());

  readEIPersonalInfo = (): Promise<PersonalInfo> =>
    this.pluginApi
      .pollForReader(1000, 2)
      .then((reader: ConnectiveReader) => reader.readPersonalInformation());

  stopWaitingForEIdCard = () => {
    this.pluginApi.stopPollingForReader();
  };

  computeSignature = (title: string, message: string, hash: string) =>
    this.pluginApi
      .pollForReader(1000, 2)
      .then((reader: ConnectiveReader) =>
        reader.computeSignature(undefined, hash, { title, message }),
      );
}

export default ConnectivePluginService;
